
<template>
  <html>
    <head>
      
    </head> 
    <body>
       <div class="container-fluid">
	<div class="row">
		<img id="header-s" src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/Loyalty-hub-header-s.png">
		<div class="title-page text-center">
			<h1>กรองรหัสแลกสินค้า</h1>
		</div>
	</div>
	<div class="row">
		<div id="lh-form" style="
    padding-left: 0px;
">
<form>
<div class="form-group">
				<label for="exampleInput" class="text-form">เบอร์โทรศัทพ*</label>
				<input type="text" class="form-control" id="exampleInput" placeholder="">
</div>

<a href="ShopView03" type="submit" class="btn btn-accept light-color font-color btn-lg btn-block mt-30">ยืนยัน</a>
        <a href="ShopView02" type="submit" class="btn btn-accept light-color font-color btn-lg btn-block mt-3">ยกเลิก</a>
</form>
      
    </div>
  </div>
	
</div>


    </body>
  </html>

  
</template>
<script>
//import Navbar from "./navbar"
export default {
name:"", 
/*components:{
    "navbar": Navbar
},*/
data() {
return {
}
 },
mounted(){
},
}
</script>
<style scoped>
@import "./Css/style.css";
h1 {
    font-size: 20px;
    color: #ffffff;
}
.btn-block {
    display: block;
    width: 100%;
    margin-top: 20px;
}
.mt-3 {
  margin-top: 126px;
  text-align: center;
  background:rgb(129, 129, 129);
}
</style>

